import {read} from './ReadHOC'
import {subscribe} from './SubscribeHOC'

export const compose =
  (...functions) =>
  (args) =>
    functions.reduceRight((arg, fn) => fn(arg), args)

export {read, subscribe}
